/* eslint-disable prefer-arrow-callback */
G.MoneyWheel = function (x, y) {
  Phaser.Group.call(this, game);
  this.position.setTo(x, y);

  this.state = game.state.getCurrentState();

  if (G.IAP) {
    this.prizeTable = G.Utils.clone(G.json['configs/spinWheels'].failFlowGold);
  } else {
    this.prizeTable = G.Utils.clone(G.json['configs/spinWheels'].failFlowNormal);
    this.prizeTableGold = G.Utils.clone(G.json['configs/spinWheels'].failFlowGold);
  }

  this.angleBetweenFields = 360 / this.prizeTable.length;
  this.anglePrizeStartOffset = this.angleBetweenFields / 2;
  this.angleDiffSinceLastPin = 0;
  this.angleBetweenPins = 15;

  this.angleSpeedMulti = 0.985;

  if (G.IAP) {
    this.wheelGfx = this.add(this.makeWheelGfx(0, 0, 'gold_wheel', this.prizeTable));
  } else {
    this.wheelGfx = this.add(this.makeWheelGfx(0, 0, 'prize_wheel_2', this.prizeTable));
    this.wheelGfxGold = this.add(this.makeWheelGfx(0, 0, 'gold_wheel', this.prizeTableGold));
  }

  this.wheelPointer = this.add(this.makeWheelPointer(0, -180, 'prize_wheel_arrow'));

  this.wheelGfx.wheelDistancePassed = 0;
  this.wheelGfx.prevDistancePassed = 0;

  this.wheelGfx.inputEnabled = true;

  this.pointer = null;
  this.pointerStartX = 0;
  this.pointerClickedDate = 0;

  this.launched = false;
  this.finished = false;

  this.wheelGfx.events.onInputDown.add(function () {
    const pointer = game.input.activePointer;
    this.pointerStartX.worldX;
    this.pointerClickedDate = Date.now();
    this.pointer = pointer;
  }, this);

  this.onLaunch = new Phaser.Signal();
  this.onFinish = new Phaser.Signal();

  this.gold = !G.saveState.isFreeMoneySpinAvailable();
};

G.MoneyWheel.prototype = Object.create(Phaser.Group.prototype);

G.MoneyWheel.prototype.update = function () {
  if (this.wheelGfxGold) {
    this.wheelGfxGold.angle = this.wheelGfx.angle;
    if (this.gold) {
      this.wheelGfx.alpha = G.lerp(this.wheelGfx.alpha, 0, 0.1, 0.02);
      this.wheelGfxGold.alpha = G.lerp(this.wheelGfxGold.alpha, 1, 0.1, 0.02);
    } else {
      this.wheelGfx.alpha = G.lerp(this.wheelGfx.alpha, 1, 0.1, 0.02);
      this.wheelGfxGold.alpha = G.lerp(this.wheelGfxGold.alpha, 0, 0.1, 0.02);
    }
  }

  this.wheelPointer.update();

  if (this.finished) return;

  if (this.launched) {
    const updateResult = this.updateLaunched();
    
    if (updateResult) {
      const tGameArea = game.state.getCurrentState().key == "Game" ? "FAIL_FLOW" : "MAP";
      const tFailFlowExtraMoves = tGameArea === "FAIL_FLOW" && (updateResult.prize[0] === "booster#6" || updateResult.prize[0] === "booster#5") ? 1 : 0;
      const tLevelExtraMoves = tFailFlowExtraMoves === 1; // *** COOK-OMT Duplicate ***

      DDNA.transactionHelper.trackRewards(updateResult.prize, [], {
        transactionType:"REWARD",
        tActionType:"WHEEL_SPIN",
        tGameArea,
        tFailFlowExtraMoves,
        tLevelExtraMoves,
      });

      this.finished = true;
      this.onFinish.dispatch(updateResult.prize);
    }
  } else if (this.pointer !== null && !this.pointer.isDown) {
    for (let i = this.children.length; i--;) {
      this.children[i].update();
    }
  }
};

G.MoneyWheel.prototype.getLabelIconByPrize = function (prize) {
  let wheel;

  if (this.wheelGfxGold && this.gold) {
    wheel = this.wheelGfxGold;
  } else {
    wheel = this.wheelGfx;
  }

  return wheel.children.find(function (e) {
    return e.prize === prize;
  });
};


G.MoneyWheel.prototype.restart = function () {
  if (!this.finished) {
    console.log('NOT FINISHED');
    return;
  }
  this.launched = false;
  this.pointer = null;
  this.finished = false;
  this.wheelGfx.inputEnabled = true;
  this.gold = !G.saveState.isFreeMoneySpinAvailable();
};

G.MoneyWheel.prototype.testSpin = function (speed, prevDistancePassed, wheelDistancePassed) {
  const wheelGfx = { angle: 0 };

  wheelGfx.angleSpeed = speed * 0.025;
  wheelGfx.prevDistancePassed = prevDistancePassed || 0;
  wheelGfx.wheelDistancePassed = wheelDistancePassed || 0;

  while (true) {
    const gift = this.updateWheel(wheelGfx);
    if (gift) return gift;
  }
};

G.MoneyWheel.prototype.launch = function (speed) {
  this.onLaunch.dispatch();

  speed = speed === undefined ? game.rnd.between(600, 1400) : speed;

  this.wheelGfx.inputEnabled = false;
  while (true) {
    const giftTestSpin = this.testSpin(speed, this.wheelGfx.prevDistancePassed, this.wheelGfx.wheelDistancePassed);
    if (giftTestSpin.keep) {
      if (Math.random() > giftTestSpin.keep) {
        speed += 80;
      } else {
        break;
      }
    } else {
      break;
    }
  }

  this.wheelGfx.angleSpeed = speed * 0.025;
  this.launched = true;
};

G.MoneyWheel.prototype.updateLaunched = function () {
  return this.updateWheel(this.wheelGfx, true);
};

G.MoneyWheel.prototype.updateWheel = function (wheel, bouncePointer) {
  wheel.angle += wheel.angleSpeed;

  const prevDistancePassed = wheel.wheelDistancePassed;
  wheel.wheelDistancePassed += wheel.angleSpeed;

  if (Math.floor(prevDistancePassed / this.angleBetweenPins) !== Math.floor(wheel.wheelDistancePassed / this.angleBetweenPins)) {
    if (bouncePointer) {
      this.wheelPointer.bounce(Math.sign(wheel.angleSpeed) * -1);
    }
    wheel.angleSpeed *= 0.95;
    if (wheel.angleSpeed < 0.25) {
      wheel.wheelDistancePassed = prevDistancePassed;
      wheel.angle = game.math.wrapAngle(prevDistancePassed);
      wheel.angleSpeed *= -0.5;
    }
  }

  wheel.angleSpeed *= this.angleSpeedMulti;

  if (Math.abs(wheel.angleSpeed) < 0.05) {
    return this.getPrizeFromAngle(wheel.angle);
  }
  return false;
};


G.MoneyWheel.prototype.getPrizeFromAngle = function (angle) {
  let table;

  if (this.wheelGfxGold) {
    table = this.gold ? this.prizeTableGold : this.prizeTable;
  } else {
    table = this.prizeTable;
  }

  let angleToDisplay = angle + 180;
  if (angle < 0) {
    angleToDisplay = 180 + angle;
  }

  return table[Math.floor(angleToDisplay / this.angleBetweenFields)];
};


G.MoneyWheel.prototype.makeWheelGfx = function (x, y, bg, prizeTable) {
  const wheel = G.makeImage(0, 0, bg, 0.5);
  wheel.labels = wheel.addChild(game.make.group());

  let prizeIndex = prizeTable.length - 1;
  for (let i = this.anglePrizeStartOffset; i < 360; i += this.angleBetweenFields) {
    const currentPrize = prizeTable[prizeIndex];


    if (currentPrize.prize[0] === 'coin') {
      const coinIcon = G.makeImage(
        G.lengthDirX(90 + i, 120, false),
        G.lengthDirY(90 + i, 120, false),
        'coin_1', 0.5, wheel,
      );
      coinIcon.angle = i + 180;
      coinIcon.prize = currentPrize.prize;

      const txt = new G.Text(
        G.lengthDirX(90 + i, 80, false),
        G.lengthDirY(90 + i, 80, false),
        currentPrize.prize[1], {
          style: 'font-white',
          fontSize: 50,
        }, 0.5, 70,
      );
      txt.angle = i + 180;
      wheel.addChild(txt);
    } else {
      const icon = G.makeImage(
        G.lengthDirX(90 + i, 110, false),
        G.lengthDirY(90 + i, 110, false),
        G.gift.getIconForType(currentPrize.prize[0]), 0.5, wheel,
      );
      icon.angle = i + 180;
      icon.prize = currentPrize.prize;
    }
    prizeIndex--;
  }

  return wheel;
};


G.MoneyWheel.prototype.makeWheelPointer = function (x, y, sprite) {
  const pointer = G.makeImage(x, y, sprite, 0.5, null);
  pointer.soundTimer = 2;
  pointer.bounce = function (sign) {
    if (this.soundTimer < 0) {
      G.sfx.pop.play();
      this.soundTimer = 2;
    }
    this.angle = 10 * sign;
  };

  pointer.update = function () {
    this.soundTimer--;
    this.angle = G.lerp(this.angle, 0, 0.2);
  };

  return pointer;
};
